import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import * as VueGoogleMaps from "vue2-google-maps"

//import socketio from 'socket.io'

import './assets/custom.css'



Vue.use(VueAxios, axios)
Vue.use(VueSession)
Vue.use(VueMoment, {
	moment,
});
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAFKwcIfE3yd0hxR2ES8A9lTRMmPlV22ow",
    libraries: "places" // necessary for places input
  }
});

//export const SocketInstance = socketio('http://localhost:32215');

//Vue.use(VueSocketIO)
Vue.config.productionTip = false
 
/*Vue.use(new VueSocketIO({
    debug: true,
    connection: 'http://localhost:32215', //options object is Optional
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_"
    },
    options: { path: '/control' }
  })
);*/

moment.tz.setDefault('Asia/Kolkata');

Vue.directive('chkperm', {
  bind: function (el, binding, vnode) {
	var userinfo = vnode.context.$session.get('user_info');
	//console.log(JSON.stringify(userinfo));
	if(userinfo.role == 1){
		return 1;
	}
	var option = 'page_'+ binding.value.page;
	var perm = binding.value.perm;
	//console.log(option+" "+perm);
	if(userinfo.options[option]){
		//console.log(userinfo.options[option].indexOf(perm));
		if(userinfo.options[option].indexOf(perm) >= -1){
			el.style.display = 'block';
		}
	}
	return el.style.display = 'none';
  }
})

new Vue({
	router,
	store,
	render: h => h(App),
	data(){
		var self = this;
		return{
			access_key: '',
			app_name: '...',
			app_name_sm: 'STREET LIGHT CCMS',
			app_version: '...',
			weburl: '',
			apiurl: '',
			//weburl: 'http://103.211.218.36',
			//apiurl: 'http://103.211.218.36:3000/',
			//weburl: 'http://216.10.251.190/',
			//httpurl: 'http://119.18.55.209:3000/',
			search_sidebar: false,
			disconnection_time: 27,
			correction_amp: 2.3,
			correction_volt: 80,
			reload_duration: 60*1000,
			status_options: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			state_options: [
				{ id: 1, value: 'in-mh', text: 'Maharashtra' },
				{ id: 2, value: 'in-up', text: 'Uttar Pradesh' },
				{ id: 3, value: 'in-hr', text: 'Haryana' },
				{ id: 4, value: 'in-rj', text: 'Rajasthan' },
				{ id: 5, value: 'in-uk', text: 'Uttarakhand' },
				{ id: 6, value: 'in-dl', text: 'Delhi' },
				{ id: 7, value: 'in-rh', text: 'Rachi' }
			],
			page_zones_perm: 'page_zones',
			page_zones_perm_enabled: 'enabled',
			page_zones_perm_view: 'view',
			page_zones_perm_edit: 'edit',
			page_zones_perm_delete: 'delete',
			page: [self.page_zones_perm],
			page_zones_perm_options: [self.page_zones_perm],
			page_perm_options: [{ value: 'enabled', text: 'Enabled' },{ value: 'view', text: 'View' },{ value: 'add', text: 'Add' },{ value: 'edit', text: 'Edit' },{ value: 'delete', text: 'Delete' }],
			page_report_perm_options: [{ value: 'enabled', text: 'Enabled' },{ value: 'view', text: 'View' },{ value: 'export', text: 'Export' }],
			page_perm_masterdevices_options: [{ value: 'enabled', text: 'Enabled' },{ value: 'view', text: 'View' },{ value: 'sms', text: 'SMS' },{ value: 'replace', text: 'Replace' },{ value: 'edit', text: 'Edit' },{ value: 'delete', text: 'Delete' },{ value: 'export', text: 'Export' }],
		} 
	},
	mounted(){
		var self = this;
		self.records = [];
	},
	beforeMount: function () {
		//console.log(this.$route.fullPath.indexOf("exports"));
		if(this.$route.fullPath.indexOf("exports") < 0){
			console.log(">>>>>>> BEFORE MOUNT >>>>>> "+this.$session.get('access_key'));
			if(this.$session.get('access_key') == '' || this.$session.get('access_key') == undefined || this.$session.get('access_key') == null){
				this.$session.destroy();
				this.$router.push('/');
			}
		}
	},
	methods: {
		is_logged_in(){
			console.log(this.$session.get('access_key'));

			if(this.$session.get('access_key') == '' || this.$session.get('access_key') == undefined || this.$session.get('access_key') == null){
				this.$session.destroy();
				this.$router.push('/');
				return 1;
			}else{
				return 0;
			}
		},
		tofixed(value, param){
			return (value).toFixed(param);
		},
		getDashboardLink(){
			var userinfo = this.$session.get('user_info');
			if(userinfo.permissions.dashboard_link != '' && userinfo.permissions.dashboard_link != undefined){
				return userinfo.permissions.dashboard_link;
			}else{
				return '/dashboard';
			}
		},
		chkperm(option,perm){
			var userinfo = this.$session.get('user_info');
			if(userinfo.role == 1 || userinfo.role == '1'){
				return 1;
			}
			var options = userinfo.options;
			if(options[option]){
				if(options[option].indexOf(perm) > -1){
					return 1;
				}
			}
			return 0;
		},
		forceLogout(msg){
			var self = this;
			var userinfo = this.$session.get('user_info');
			if(userinfo.permissions.multi_login <= 0 || userinfo.permissions.multi_login == '0'){
				this.$bvModal.msgBoxOk(msg, {
					title: 'Security Issue',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'Logout',
					okOnly: true,
					footerClass: 'p-2',
					backdrop: 'static',
					hideHeaderClose: true,
					centered: true
				})
				.then(value => {
					if(value == true){
						//self.$session.destroy();
						self.$session.remove('access_key');
						self.$session.remove('user_info');
						self.$router.push('/')
					}
				})
				.catch(err => {
					// An error occurred
					console.log(err);
				})
			}
		},
		showMessage(title, msg, okTitle, callback=''){
			this.$bvModal.msgBoxOk(msg, {
				title: title,
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: okTitle,
				okOnly: true,
				footerClass: 'p-2',
				backdrop: 'static',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					if(callback != ''){
						callback();
					}
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		}
	}
}).$mount('#app')
